// extracted by mini-css-extract-plugin
export default {"btop":"e1a36263ea _3770f831b1 a9fa6f85f8","icon":"b6125802c5 d8b2b9e3fc","btoppink":"f6ed75c439 _635d0ab44b"};